import { z } from "zod";
import { schemes } from "../schema-validation";
import { shiftSchema } from "../shifts/schemas/shiftSchema";
import { baseEventInput } from "./baseEvent";

export const shiftEvent = baseEventInput.extend({
  source: z.literal("shifts"),
  employeeCheckId: schemes.uuid(),
  companyId: schemes.uuid(),
  shiftId: schemes.uuid(),
  payload: shiftSchema.partial(),
});

export type ShiftEvent = z.infer<typeof shiftEvent>;
